import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { DefaultSeoService } from './default-seo.service';

import { LanguageService } from '../translate/language.service';

/**
 * Belongs on the `:lang` shell: a parent resolver runs before its children, so a page with its own
 * SEO data overwrites the site texts and a page without any keeps them.
 */
export const defaultSeoResolver: ResolveFn<void> = (route) => {
  const defaultSeoService = inject(DefaultSeoService);
  const languageService = inject(LanguageService);

  return defaultSeoService.apply(languageService.getLanguageForRoute(route));
};
